const loginState = {
  loading: false,
  email: '',
  password: '',
};

export default loginState;
